import {
  Fansea3DStageLightSetup,
  Fansea3DStageLightType,
} from './Fansea3DStageLight';

export const defaultLightSetups: Fansea3DStageLightSetup[] = [
  {
    name: 'Default Environment',
    lights: [
      {
        name: 'environmentLight',
        type: Fansea3DStageLightType.Environment,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        intensity: 0.25,
        scale: 0.25
      },
    ],
  },
  {
    name: 'Studio Lights',
    lights: [
      {
        name: 'keyLight',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0.5, y: 0.75, z: 1 },
        intensity: 1,
        scale: 0.25
      },
      {
        name: 'fillLight',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: -0.5, y: 0.75, z: 1 },
        intensity: 0.5,
        scale: 0.25
      },
      {
        name: 'rimLight',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0, y: 0.75, z: -1 },
        intensity: 1.5,
        scale: 0.25
      },
    ],
  },
  // Twitch streamer setup with purple and cyan backlights
  {
    name: 'Lets Play (purple and cyan)',
    lights: [
      {
        name: 'keyLight',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0, y: 0.75, z: 1 },
        intensity: 1,
        scale: 0.25
      },
      {
        name: 'rimLightCyanBack',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 0, g: 1, b: 1 },
        specular: { r: 0, g: 1, b: 1 },
        position: { x: 1, y: 0.75, z: -1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightCyanFront',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 0, g: 1, b: 1 },
        specular: { r: 0, g: 1, b: 1 },
        position: { x: 1, y: 0.75, z: 1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightPurpleFront',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 0, b: 1 },
        specular: { r: 1, g: 0, b: 1 },
        position: { x: -1, y: 0.75, z: 1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightPurpleBack',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 0, b: 1 },
        specular: { r: 1, g: 0, b: 1 },
        position: { x: -1, y: 0.75, z: -1 },
        intensity: 2,
        scale: 0.25
      },
    ],
  },
  // Another "YouTube" setup but this time with teal and orange back lights
  {
    name: 'Teal and Orange',
    lights: [
      {
        name: 'keyLight',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0, y: 0.75, z: 1 },
        intensity: 1,
        scale: 0.25
      },
      {
        name: 'rimLightTealBack',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 0, g: 0.33, b: 0.33 },
        specular: { r: 0, g: 0.33, b: 0.33 },
        position: { x: 1, y: 0.75, z: -1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightTealFront',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 0, g: 0.33, b: 0.33 },
        specular: { r: 0, g: 0.33, b: 0.33 },
        position: { x: 1, y: 0.75, z: 1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightOrangeBack',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 0.33, b: 0 },
        specular: { r: 1, g: 0.33, b: 0 },
        position: { x: -1, y: 0.75, z: -1 },
        intensity: 2,
        scale: 0.25
      },
      {
        name: 'rimLightOrangeFront',
        type: Fansea3DStageLightType.Point,
        diffuse: { r: 1, g: 0.33, b: 0 },
        specular: { r: 1, g: 0.33, b: 0 },
        position: { x: -1, y: 0.75, z: 1 },
        intensity: 2,
        scale: 0.25
      },
    ],
  },
  // strip of 4 bright lights along the front edge above the model and one softer strip of lights behind the model creating stark contrast of shadow on the sides
  {
    name: 'Museum',
    lights: [
      {
        name: 'frontLight',
        type: Fansea3DStageLightType.Strip,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0, y: 1, z: 1 },
        size: { width: 1, height: 0 },
        density: 4,
        intensity: 2,
        scale: 0.25,
      },
      {
        name: 'backLight',
        type: Fansea3DStageLightType.Strip,
        diffuse: { r: 1, g: 1, b: 1 },
        specular: { r: 1, g: 1, b: 1 },
        position: { x: 0, y: 1, z: -1 },
        size: { width: 1, height: 0 },
        density: 4,
        intensity: 1,
        scale: 0.25,
      },
    ],
  },
];
